const meta = {
  'pinned-scopes': 'Pinned scopes',
  'time-ranges': 'Time ranges',
  comments: 'Comments',
};

export default meta;
